import { Inject, Injectable, Injector } from '@angular/core';

import { Utilities_FlowService } from './Utilities.flow.index';
import { IntraOne_FlowService } from './IntraOne.flow.index';

import { app_send_data_1310_by_shipping_container_Id_testService } from './app.flow.index';

import { $frontendTypes } from './app.frontend.types'

@Injectable({ providedIn: 'root' })
export class app_FlowService {

  constructor(
    private injector: Injector
  ) {
    this.Utilities = this.injector.get(Utilities_FlowService);
    this.IntraOne = this.injector.get(IntraOne_FlowService);
  }

    public Utilities: Utilities_FlowService;
    public IntraOne: IntraOne_FlowService;
  public app: app_FlowService = this;

  // injecting lazily in order to avoid circular dependencies
 
  private _send_data_1310_by_shipping_container_Id_test: app_send_data_1310_by_shipping_container_Id_testService;
  public async send_data_1310_by_shipping_container_Id_test($inParams: { shipping_container_id: number, mode: string, is_hold?: boolean }): Promise< { reason?: string[] }> {
    if(!this._send_data_1310_by_shipping_container_Id_test) { 
      this._send_data_1310_by_shipping_container_Id_test = this.injector.get(app_send_data_1310_by_shipping_container_Id_testService);
    }
    return this._send_data_1310_by_shipping_container_Id_test.run($inParams);
  }
   
   

   
}
